module.exports = __webpack_public_path__ + "img/noodles-1.100f0388.jpg";